// src/store/inscripcionTours.js
import { defineStore } from 'pinia'

export const useInscripcionTours = defineStore('peleador', {  // mismo id que el original → persistencia conservada
  state: () => ({
    // ── Paso 1: Datos personales ──────────────────────────────────────────
    imagenPerfil: '',
    nombre:       '',
    apellido:     '',
    email:        '',
    telefono:     '',
    nacionalidad: '',
    direccion:    '',

    redesSociales: {
      instagram: '',
      facebook:  '',
      youtube:   '',
      twitter:   '',
    },

    // ── Paso 2: Datos de combate ──────────────────────────────────────────
    fechaNacimiento: '',
    genero:          '',
    rangoCinta:      '',
    matchPreference: '',
    categoriaPeso:   null,
    academia:        '',
    aceptaTerminos:  false,

    // ── Paso 3: Pago ──────────────────────────────────────────────────────
    metodoPago: null,
  }),

  actions: {
    resetFormulario() {
      this.imagenPerfil   = '';
      this.nombre         = '';
      this.apellido       = '';
      this.email          = '';
      this.telefono       = '';
      this.nacionalidad   = '';
      this.direccion      = '';
      this.redesSociales  = { instagram: '', facebook: '', youtube: '', twitter: '' };
      this.fechaNacimiento = '';
      this.genero         = '';
      this.rangoCinta     = '';
      this.matchPreference = '';
      this.categoriaPeso  = null;
      this.academia       = '';
      this.aceptaTerminos = false;
      this.metodoPago     = null;
    },
  },

  persist: true,   // pinia-plugin-persistedstate
})